export const theme = {
  primaryColor: "#000000",
  secondaryColor: "#a01111",
  textAlign: "center",
  fontSize: "2.5rem",
};
